<template>
  <div class="avatar u-wrapper-panel u-row u-overflow-y-scroll--sm">
    <div ref="container" class="u-full-height u-w6of8 u-relative u-w8of8--sm u-z-back u-w5of8--md">
      <p class="u-w8of8 u-center u-pad-t-xxl u-white u-absolute">{{$t('avatar.custom')}}</p>
      <div class="u-wrapper-panel u-z-middle u-white">
        <div class="arrow-left arrow-left--top" @click="indexHead = getPrevIndex(avatar.heads, indexHead)">
          <img src="/images/arrow--left.png">
        </div>
        <div class="arrow-right arrow-right--top" @click="indexHead = getNextIndex(avatar.heads, indexHead)">
          <img src="/images/arrow--right.png">
        </div>
        <div class="arrow-left arrow-left--middle" @click="indexSkin = getPrevIndex(avatar.skins, indexSkin)">
          <img src="/images/arrow--left.png">
        </div>
        <div class="arrow-right arrow-right--middle" @click="indexSkin = getNextIndex(avatar.skins, indexSkin)">
          <img src="/images/arrow--right.png">
        </div>
        <div class="arrow-left arrow-left--bottom" @click="indexBody = getPrevIndex(avatar.bodys, indexBody)">
          <img src="/images/arrow--left.png">
        </div>
        <div class="arrow-right arrow-right--bottom" @click="indexBody = getNextIndex(avatar.bodys, indexBody)">
          <img src="/images/arrow--right.png">
        </div>

        <div class="avatar__bottom u-absolute u-flex u-full-width u-center">
           <app-button @click="onRandom" :hasGradient="true" :icon="true" class="btn-random u-inline-block">
              <img src="/images/dice.png" alt="icon picture" class="t-text--small"/>
              <p class="t-text u-white">{{$t('avatar.random')}}</p>
           </app-button>
          <app-button v-show="$device.isTablet" class="avatar__bottom__btn u-inline-block u-marg-l-sm t-text" :hasGradient="true" @click="onSave">
            {{$t('button.save')}}
          </app-button>
        </div>
      </div>
      <div ref="flash" class="u-wrapper-panel u-bg-white u-z-front u-pointer-none u-none" />
    </div>
    <div v-show="!$device.isTablet" class="u-w2of8 u-w3of8--md u-z-back">
      <div class="u-middle u-center u-full-height u-bg-grey u-flex u-column u-pad-b-md--sm u-full-width--sm ">
        <app-account-info 
          :isFull="true"
          :firstName="firstName"
          :lastName="lastName"
          :company="company"
          :role="role"
          :picture="picture"
          :email="email"
          @change="onUpdateFields"
        />
        <div class="u-row">
          <app-button class="u-inline-block u-marg-r-sm" :hasGradientBorder="true" @click="$router.push($local('account'))">
            Back
          </app-button>
          <app-button class="u-inline-block" :hasGradient="true" @click="onSave">
            {{$t('button.save')}}
          </app-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WebGL } from '@/webGL/WebGL'
import { Body } from '@/webGL/objects/Body'
import { Arms } from '@/webGL/objects/Arms'
import { Room } from '@/webGL/objects/Room'
import { FitTo } from '@/utils/FitTo'
import { Vector3, AmbientLight, Box3, DirectionalLight } from 'three'

import gsap from 'gsap'

import AppAccountInfo from '@/components/AppAccountInfo'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

import Account from '@/components/Account'

export default {
  components: {
    AppAccountInfo
  },

  mixins: [
    Account
  ],

  data () {
    return {
      avatar: require('@/assets/data/avatar'),
      indexHead: -1,
      indexBody: -1,
      indexSkin: -1
    }
  },

  components: {
    AppAccountInfo
  },
  
  computed: {
    data () {
      return this.$store.getters['user/avatar']
    }
  },

  created () {
    // this.webGL = new WebGL(true, false)
    this.webGL = new WebGL(false, false)
    this.srcImg = ''
  },

  mounted () {
    this.webGL.el = this.$refs.container

    this.heads = new Body({ urls: this.avatar.heads, fakePosY: 0 })
    this.body = new Body({ urls: this.avatar.bodys, fakePosY: 0 })
    this.webGL.scene.add(this.heads, this.body)

    this.fitTo = new FitTo(this.webGL.camera)

    // this.controls = new OrbitControls( this.webGL.camera, this.$el )
    this.arms = new Arms({url: this.avatar.arms})
    this.webGL.scene.add(this.arms)

    this.room = new Room({url: this.avatar.room})
    this.webGL.scene.add(this.room)

    Promise.all([this.heads.promise, this.body.promise]).then(()=>{
      let indexHead = this.avatar.heads.findIndex(head => head === this.data.head)
      let indexBody = this.avatar.bodys.findIndex(body => body === this.data.body)
      let indexSkin = this.avatar.skins.findIndex(skin => skin === this.data.skin)

      this.indexHead = indexHead < 0 ? Math.floor(Math.random() * this.avatar.heads.length) : indexHead
      this.indexBody = indexBody < 0 ? Math.floor(Math.random() * this.avatar.bodys.length) : indexBody
      this.indexSkin = indexSkin < 0 ? Math.floor(Math.random() * this.avatar.skins.length) : indexSkin
      this.changeColor()

      const ambient = new AmbientLight(0x555555, 1)
      this.webGL.scene.add(ambient)

      const directional = new DirectionalLight(0xffffff, 1)
      directional.position.set(-5, -5, -5)
      directional.lookAt(0, 0, 0)
      this.webGL.scene.add(directional)

      this.webGL.camera.position.copy(this.fitTo.fit(this.getBox(), .5, {vector: new Vector3(0, 0, 1)}).position)
      this.webGL.camera.look = new Vector3(0,0,0)
      this.canvasTest = document.createElement("canvas")

      this.onResize()
    })
  },

  methods: {
    onResize () {
      this.webGL.resize({
        width: this.$refs.container.offsetWidth,
        height: this.$refs.container.offsetHeight
      })

      const fitTo = this.fitTo.fit(this.getBox(), .6, {vector: new Vector3(0, 0, 1)})

      this.webGL.camera.position.copy(fitTo.position)
      this.webGL.camera.look = fitTo.look
      this.canvasTest = document.createElement("canvas")
    },
    getBox () {
      const box = new Box3().makeEmpty()
      box.union(this.heads.boundingBox)
      box.union(this.body.boundingBox)

      return box
    },
    getPrevIndex (array, index) {
      return index === 0 ? array.length - 1 : index - 1
    },
    getNextIndex (array, index) {
      return (index + 1) % array.length
    },
    changeColor () {
      this.heads.color = this.avatar.skins[this.indexSkin]
      this.body.color = this.avatar.skins[this.indexSkin]
      this.arms.color = this.avatar.skins[this.indexSkin]
    },
    onRandom () {
      this.indexHead = Math.floor(Math.random() * this.avatar.heads.length)
      this.indexBody = Math.floor(Math.random() * this.avatar.bodys.length)
      setTimeout(()=>{
        this.indexSkin = Math.floor(Math.random() * this.avatar.skins.length)
      }, 500)
    },
    async onSave () {
      await this.capture()

      const data = JSON.stringify({
        head: this.avatar.heads[this.indexHead],
        body: this.avatar.bodys[this.indexBody],
        skin: this.avatar.skins[this.indexSkin]
      })

      let promises = []

      promises.push(this.$store.dispatch('user/avatar', data))
      // substring is used to remove first car that specify type
      promises.push(this.$store.dispatch('user/avatarPicture', { image: JSON.stringify(this.srcImg.substring(23)) }))
      // promises.push()

      Promise.all(promises).then(async ()=>{
        this.webGL.onDestroy()
        this.heads.onDestroy()
        this.body.onDestroy()
        this.arms.onDestroy()

        await this.$store.dispatch('user/update', {
          firstName: this.fields.firstName,
          lastName: this.fields.lastName,
          company: this.fields.company,
          role: this.fields.role
        })
        this.$router.push({...this.$local('city')})
      })
    },
    capture () {
      return new Promise((resolve, reject) => {
        const sourceSize = 800
        const destSize = 500
        this.$refs.flash.style.display = 'block'
        this.$refs.flash.style.opacity = 1
        this.webGL.resize({
          width: 800,
          height: 800
        })


        requestAnimationFrame(() => {
          this.webGL.renderer.webGLRenderer.preserveDrawingBuffer = false
          this.canvasTest.width = destSize
          this.canvasTest.height = destSize
          const context = this.canvasTest.getContext('2d')
          context.drawImage(this.webGL.renderer.canvas, (sourceSize - destSize) * .5, (sourceSize - destSize) * .5, destSize, destSize, 0, 0, destSize, destSize)
          this.srcImg = this.canvasTest.toDataURL('image/jpeg')
          this.onResize()
          gsap.fromTo(this.$refs.flash, {opacity: 1}, {
            opacity: 0,
            duration: .5,
            onComplete: () => {
              this.$refs.flash.style.display = 'none'
              resolve()
            }
          })

          this.webGL.renderer.webGLRenderer.preserveDrawingBuffer = true
        })
      })
    }
  },
  watch: {
    indexHead () {
      this.heads.index = this.indexHead
    },
    indexBody () {
      this.body.index = this.indexBody
    },
    indexSkin () {
      this.changeColor()
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'

.img-test
  position absolute
  top 0
  left 0
  width 300px
  border solid 2px black

.arrow-left
  position absolute
  cursor pointer
  left 20%

  @media ( max-width: $mq-breakpoints.tablet )
    left 20%
  @media ( max-width: $mq-breakpoints.mobile )
    left 10%

  &--top
    top 30%
  &--middle
    top calc( 50% - 26px )
  &--bottom
    bottom 30%

.arrow-right
  position absolute
  cursor pointer
  right 20%

  @media ( max-width: $mq-breakpoints.tablet )
    right 20%
  @media ( max-width: $mq-breakpoints.mobile )
    right 10%
  
  &--top
    top 30%
  &--middle
    top calc( 50% - 26px )
  &--bottom
    bottom 30%

.skin-wrapper
  position  absolute
  top 0
  left 0
  width 200px
  
.avatar__bottom 
  left 50%
  bottom 10vh
  transform translateX(-50%)
  
  &__btn
    // padding 22px 30px
    @media ( max-width: $mq-breakpoints.mobile )
      padding 22px 30px !important

.btn-random 
  padding 7px 50px
  img 
    margin 0 10px 0 0 
    height 30px
  p
    margin 0

</style>